import React from "react";
import R14, { View, StyleSheet, Button } from "../../core";
import { commonStyles } from "../../assets/css/commonStyle";
import { PAY_ENVIRONMENT, PAYMENT_MODE } from "../../constant/app.data.constant";
import GooglePayButton from "@google-pay/button-react";
import ApplePayment from "./ApplePayment";
import PaymentHelpers from "../../utils/PaymentHelpers";

export default R14.connect(
    class PaymentOptions extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                paymentDataRequest: {},
                isApplePayEnabled: false
            };
        }

        isReadyToPay = async (isReady) => {
            console.warn('Is Pay Ready ', isReady);
            return isReady;
        };

        onPaymentDataChanged = async (data) => {
            console.warn(data)
            return {};
        };

        onPaymentAuthorized = async (paymentRequest) => {
            console.warn(paymentRequest)
            // TODO: implement funds check
            if (true) {
                return { transactionState: "SUCCESS" };
            } else {
                return {
                    transactionState: "ERROR",
                    error: {
                        reason: "PAYMENT_DATA_INVALID",
                        message: "Insufficient funds (shouldSucceed is false), click Pay again.",
                        intent: "PAYMENT_AUTHORIZATION",
                    },
                };
            }
        };

        processPayment = async (paymentDataResponse) => {
            // console.log('payment Data Response', paymentDataResponse);
            const { onPaymentDone, user, onModelClose, displayLoader, bill} = this.props;
            if(!!onModelClose)
                onModelClose();
            if(!!displayLoader)    
                displayLoader();
                
            let token = paymentDataResponse.paymentMethodData.tokenizationData.token;
            // console.log('Token: ', token);
            if (!!token) {
                let payload = {
                    tokendetails: {
                        cardtoken: JSON.parse(token).id,
                        payment_intent: 0,
                        merchantAccountNumber: bill.tokendetails.merchantAccountNumber,
                    },
                    transactiondetails: {
                        total_amount: parseFloat(bill.transactiondetails.total_amount),
                        currency: bill.transactiondetails.currency,
                        purchase_level: 1,
                        transaction_date: new Date(),
                        transaction_description: `bill payment ${bill.payee}`,
                        session_id: bill.session_id
                    },
                    billingaddress: {
                        billing_username: user.pid,
                        user_email: paymentDataResponse.email,
                        phone_Number: paymentDataResponse.shippingAddress.phoneNumber,
                        user_address1: paymentDataResponse.shippingAddress.address1,
                        user_address2: paymentDataResponse.shippingAddress.address2 + " " + paymentDataResponse.shippingAddress.locality,
                        user_zip: paymentDataResponse.shippingAddress.postalCode,
                        user_city: paymentDataResponse.shippingAddress.administrativeArea,
                        user_state: paymentDataResponse.shippingAddress.countryCode,
                    },
                };
                if(!!bill && !!bill.customerId)
                    payload.billingaddress.customerId = bill.customerId;
                if(this.props && this.props.billDetailId) payload.billDetailId = this.props.billDetailId;
                let response = {};
                response = await this.props.app.dm.billDetails.stripeCheckout(payload);
                response.paymentMode = PAYMENT_MODE.ANDROID_PAY;
                response.totalAmount = payload.transactiondetails.total_amount;
                response.achBankAccountId = "Google Wallet";
                onPaymentDone(response);
            }
        };

        loadPaymentError = async (error) => {
            console.error("On Payment Error", error);
            let response = {
                success: false,
                error: error.statusMessage,
                isCancelByUser: false
            };
            const { onPaymentDone } = this.props;
            onPaymentDone(response);
        };

        loadPaymentCancel = async (cancel) => {
            console.warn("On Payment Cancel ", cancel);
            let response = {
                success: false,
                error: `${cancel.statusCode}: Payment cancelled by user.`,
                isCancelByUser: true
            };
            const { onPaymentDone } = this.props;
            onPaymentDone(response);
        }; 
        
        handleApplePayEnabled = () => this.setState({ isApplePayEnabled: true });


        render() {
            const { isLoading, externalClient, rtpPay = false, googleBtnStyle, bulkPay, showGooglePay = true, cancelBtnStyle = false, cancelText = "Cancel", cancelTextStyle, onCancel, gpayContainer, buttonColor, bill } = this.props;
            const isSafariBrowser = navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf("Chrome") <= -1;
            let payload = PaymentHelpers.paymentDataRequest(bill);
            let stripeDetails = PaymentHelpers.stripeDetails();
            const { isApplePayEnabled } = this.state;
            return (
                <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.flexWrap, !!bulkPay && styles.customJustifyContentFlexEnd, commonStyles.flexGrow0, commonStyles.alignItemsCenter, commonStyles.justifyContentCenter, gpayContainer]}>
                  {!!cancelBtnStyle ? <Button
                                title={cancelText}
                                key="cancel"
                                style={cancelBtnStyle}
                                titleTextStyle={cancelTextStyle}
                                onPress={onCancel}
                            /> : null }
                    {!isSafariBrowser ? (
                    <View style={[googleBtnStyle, !!isLoading ? commonStyles.disable : null]}>
                        <GooglePayButton
                            buttonSizeMode="fill"
                            buttonColor= {!!buttonColor ?  buttonColor : "white" }
                            buttonType="short"
                            className= {[!!showGooglePay ? "" : !!externalClient ? "btnpchclaims external-client": !!rtpPay ? `btnRTPPay ${isLoading ? "btnDisabled" :""}` :""]}
                            environment={PAY_ENVIRONMENT.ENVIRONMENT}
                            paymentRequest={payload}
                            onLoadPaymentData={this.processPayment}
                            onError={this.loadPaymentError}
                            onCancel={this.loadPaymentCancel}
                            onReadyToPayChange={this.isReadyToPay}
                            onPaymentAuthorized={this.onPaymentAuthorized}
                            style={
                                !!showGooglePay ? null :
                                    {
                                        flexBasis: "100%",
                                        border: "0px solid rgba(21, 27, 38, 0.4)",
                                        height: 24,
                                        minHeight: 24,
                                        borderTopLeftRadius: 5,
                                        borderTopRightRadius: 5,
                                        borderBottomLeftRadius: 5,
                                        borderBottomRightRadius: 5,
                                        padding: 0,
                                    }
                            }
                            onPaymentDataChanged={(data) => this.onPaymentDataChanged(data)}
                        />
                    </View>
                    ): ( 
                        <View style={[styles.width98, !!isApplePayEnabled ? null : commonStyles.disable]}>
                            <ApplePayment
                                props={this.props}
                                paymentDataRequest={payload}
                                stripeDetails={stripeDetails}
                                proceedToApplePayStyle={styles.minWidth200}
                                handleApplePayEnabled={this.handleApplePayEnabled}
                            />    
                        </View>
                    )}                    
                </View>                
            )
        }
    }
);

const styles = StyleSheet.create({
    achPaymentBtn: {
        width: 110,
        marginRight: 10,
        marginLeft: 10,
        height: 24,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: "none",
        borderRadius: 5,
        padding: 0,
        backgroundColor: "#d71996",
        screen: ({width}) =>{
            if(width <= 991){
                return {
                    width: 110
                }
            }
        }
    },       
    minWidth200: {
        minWidth: 100,
        screen: ({width}) => {
            if(width <= 991){
                return {
                    minWidth: 95
                }
            }
        }
    },
    customJustifyContentFlexEnd: {
        screen: ({ width }) => {
            if (width <= 991) {
                return {
                    justifyContent: "flex-end",
              }
            }
          }  
    },
    width98: {
        width: "98%",
        marginLeft: -8,
    }
    
    
});
